import React, { useState } from "react";
import { InfiniteGridProps } from "@egjs/react-infinitegrid";
import { Container, debounce } from "@material-ui/core";

import { IProject } from "../../store/feedStoreTypes";
import LoadingPanel from "../LoadingPanel";
import IrregularListView, {
  IrregularItem as ViewItemProps,
} from "./IrregularListView";
import { FakeElement } from "./style";

interface Props extends ViewItemProps {
  list: IProject[];
  isLoading: boolean;
  nullList: JSX.Element | null;
  onGetProjects: () => void;
}

function IrregularList({
  list,
  isLoading,
  nullList,
  languageCode,
  onGetProjects,
  onClickItem,
}: Props) {
  const {
    sessionStorage,
    location: { pathname },
  } = window;

  const [isLayoutComplete, setLayoutComplete] = useState(false);

  // list items
  const items = list.map((project) => ({ project, languageCode, onClickItem }));

  // IntersectionObserver를 이용한 무한 스크롤
  const fetchMoreObserver = new IntersectionObserver(
    ([{ target, isIntersecting }]) => {
      if (isIntersecting) {
        fetchMoreObserver.unobserve(target);
        debounce(onGetProjects, 300)();
      }
    }
  );

  const gridLayoutProps: InfiniteGridProps = {
    options: {
      useFit: true,
      useRecycle: true,
      resizeDebounce: 300,
      maxResizeDebounce: 500,
    },
    layoutOptions: { margin: 10, align: "center" },
    onLayoutComplete: () => {
      // layout complete 후 list 노출 시키기 위함
      setLayoutComplete(true);

      if (items.length <= 0) return;

      const fetchMore = document.getElementById(
        items[items.length - 1].project.projectId
      );
      if (fetchMore) {
        fetchMoreObserver.observe(fetchMore);
      }
      // scroll 위치 복원
      const posKey = encodeURI(`pos_${pathname}`);
      const posId = sessionStorage.getItem(posKey);
      if (!posId) return;
      sessionStorage.removeItem(posKey);
      const posElement = document.getElementById(posId);
      posElement?.scrollIntoView({ block: "center" });
    },
  };

  const NullItem = () => {
    if (!isLoading && !items.length) return nullList;
    return <FakeElement />;
  };

  return (
    <Container
      maxWidth={false}
      component="main"
      style={{ height: "100%", paddingTop: "56px" }}
    >
      <NullItem />
      <LoadingPanel isOpen={isLoading} backdropInvisible />
      <div style={{ visibility: isLayoutComplete ? "visible" : "hidden" }}>
        <IrregularListView list={items} gridLayoutProps={gridLayoutProps} />
      </div>
    </Container>
  );
}

export default IrregularList;
